import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import EnumerationComboBoxViewModelType from '@/ViewModels/Controls/EnumerationComboBoxViewModel';
import DropDownListType from '@/Controls/DropDownList';

export default class EnumerationComboBox extends Control {

    private DropDownList = ComponentManager.getControl<typeof DropDownListType>('DropDownList');
    private jQueryControl: JQuery;
    private dropDownList: DropDownListType;

    public constructor(private viewModel: EnumerationComboBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'enumerationcombobox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            parentLocator: this.viewModel.parentLocator,

            locator: this.viewModel.locator,

            focus: this.viewModel.isFocusable,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.dropDownList != null) {
            this.dropDownList = new this.DropDownList(this.viewModel.dropDownList);
            let tuple = this.dropDownList.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }

    public addLabelReference(label: JQuery): JQuery {
        return this.dropDownList.addLabelReference(label);
    }
}

ComponentManager.setControl('EnumerationComboBox', EnumerationComboBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');